// Backend root. Override with VITE_API_BASE_URL in .env.local for non-default
// dev setups. The dev cert is self-signed; Chrome must have visited
// https://localhost:44303 once with "advanced → proceed" to trust it.
export const apiBaseUrl =
  import.meta.env.VITE_API_BASE_URL || 'https://localhost:44303'
export const oidcClientId = 'Api_App'
export const oidcScope = 'Api offline_access roles email profile'
